import React, { FunctionComponent } from "react";
import ErrorMessage from "./ErrorMessage";
import { BaseError } from "../../types/errors/AllBrightError";
import styled from "styled-components";

import { H5 } from "../Typography";
import { colours } from "../../utils";

interface StyleProps {
  errors?: number;
}

interface ErrorDisplayProps {
  errors: BaseError[];
}

const ErrorDisplay: FunctionComponent<ErrorDisplayProps> = (props) => {
  return (
    <S.HiddenContainer errors={props.errors.length} data-cy="error-display">
      {props.errors.length > 0 && (
        <H5 weight="600">Please address the following errors:</H5>
      )}
      <S.ErrorList>
        {props.errors.map((error) => (
          <ErrorMessage key={error.id} error={error} />
        ))}
      </S.ErrorList>
    </S.HiddenContainer>
  );
};

// If no errors exist before or after, don't render. If error messages are unchanged, don't render
// For more info: https://react.dev/reference/react/memo#parameters
const arePropsEqual = (
  prevProps: ErrorDisplayProps,
  nextProps: ErrorDisplayProps
) => {
  if (prevProps.errors.length < 1 && nextProps.errors.length < 1) return true;

  const prevMessageLength = prevProps.errors.reduce(
    (message, error) => message + error.message,
    ""
  );
  const nextMessageLength = nextProps.errors.reduce(
    (message, error) => message + error.message,
    ""
  );
  if (prevMessageLength === nextMessageLength) return true;
  return false;
};

const S = () => {};

S.HiddenContainer = styled.div<StyleProps>`
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  padding: ${(p) => (p.errors > 0 ? "10px 20px" : "0")};
  border-radius: 5px;
  background: ${colours.errorYellow};
  overflow-x: visible;
  overflow-y: hidden;
  transition: max-height 0.2s linear;
  max-height: ${(p) => (p.errors > 0 ? `${40 + p.errors * 21}` : "0")}px;
`;

S.ErrorList = styled.ul`
  list-style-position: inside;
`;

export default React.memo(ErrorDisplay, arePropsEqual);
